import { Grid, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

export const Information = () => {
  const { t } = useTranslation();
  const routerLink = {
    color: '#FFF',
    textDecoration: 'none',
  };

  return (
    <Grid
      container
      direction="column"
      height="100%"
      justifyContent="space-between"
      spacing="10"
    >
      <Grid item>
        <Typography variant="h4" color="inherit" fontFamily="JHFontBold">
          {t('Information')}
        </Typography>
      </Grid>
      <Grid item>
        <Link
          variant="h5"
          color="#FFF"
          underline="hover"
          href="https://www.jungheinrich.com/impressum-12324"
          target="_blank"
          rel="noreferrer noopener"
        >
          {t('Imprint')}
        </Link>
      </Grid>
      <Grid item>
        <Link
          variant="h5"
          color="#FFF"
          underline="hover"
          href="https://www.jungheinrich.com/privacy-policy-for-digital-services-by-jungheinrich-924562"
          target="_blank"
          rel="noreferrer noopener"
        >
          {t('DataProtection')}
        </Link>
      </Grid>
      <Grid item>
        <RouterLink
          to="/cookieDeclaration"
          style={routerLink}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = 'none';
          }}
        >
          <Typography variant="h5" color="inherit">
            {t('CookieDeclaration')}
          </Typography>
        </RouterLink>
      </Grid>
    </Grid>
  );
};
